const WalletGetter = {
    walletPinStatus: s => s.transactionPinStatus,
    walletPolicies: s => s.walletPolicies,
    walletRequests: s => s.walletRequests
};

export default WalletGetter;